import { newsService } from "../api/newsService";

export const deleteNews = async (id, id_img) => {
  return newsService.deleteNews(id, id_img);
};

export default deleteNews;